var map = {
	"./0x project.svg": 19619,
	"./ARK.svg": 68384,
	"./Augur.svg": 22012,
	"./Bancor.svg": 90026,
	"./Basic attention token.svg": 70690,
	"./Binance coin.svg": 52960,
	"./Bitcoin Cash.svg": 59840,
	"./Bitcoin Gold.svg": 11513,
	"./Bitcoin.svg": 50509,
	"./Bitshares.svg": 96778,
	"./Cardano.svg": 31499,
	"./Civic.svg": 55319,
	"./Dash.svg": 32803,
	"./Decred.svg": 36079,
	"./Digi byte.svg": 88745,
	"./EOS.svg": 14780,
	"./ETHOS.svg": 50690,
	"./Ethereum Classic.svg": 39065,
	"./Ethereum.svg": 5436,
	"./Gnosis.svg": 91348,
	"./Golem.svg": 88219,
	"./IOTA.svg": 42842,
	"./Iconomi.svg": 5450,
	"./Komodo.svg": 20385,
	"./Kyber network.svg": 3369,
	"./Litecoin.svg": 58606,
	"./Monero.svg": 68949,
	"./NEM.svg": 29130,
	"./Neo.svg": 17707,
	"./Omnise go.svg": 93272,
	"./PIVX.svg": 37807,
	"./QTUM.svg": 91118,
	"./Raiden.svg": 34344,
	"./Ripple.svg": 57303,
	"./SingularDTV.svg": 96057,
	"./Status.svg": 77748,
	"./Steem.svg": 58509,
	"./Stellar lumens.svg": 16589,
	"./Storj.svg": 36702,
	"./Stratis.svg": 49808,
	"./Tether USD.svg": 94267,
	"./Tron.svg": 51646,
	"./USD Coin.svg": 10244,
	"./Vechain.svg": 28218,
	"./WAVES.svg": 88953,
	"./Zcash.svg": 19884
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11557;